<template>
  <div class="layout-bd">
    <div class="ub" :style="{ 'min-height': windowHeight - 112 + 'px' }">
      <!-- 侧边菜单 -->
      <div class="layout-aside">
        <div class="logo">
          <img v-if="userInfo.factoryId !== '617804832337023009'" src="@/images/layout/logo1.png" alt="" />
          <img v-else src="@/images/layout/logo2.png" alt="" />
        </div>
        <div class="bar">
          <img src="@/images/layout/bar.png" alt="" />
        </div>
        <div class="menu">
          <ul class="title">
            <li v-for="item in appMenu" :key="item.menuId">
              <div class="tit-h1" v-if="item.loadRes !== '/'">
                <h1>{{ item.menuName }}</h1>
              </div>
              <ul class="sub-title">
                <li v-for="value in item.children || []" :key="value.menuId" @click="onMenuLink(value)" :class="{ cur: currentPath === value.loadRes }">
                  <div class="tit-icon">
                    <i class="icon" :class="value.menuIcon"></i>
                  </div>
                  <div class="tit-h2">
                    <h2>{{ value.menuName }}</h2>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- 主要内容 -->
      <div class="layout-section ub-f1">
        <t-header v-show="$route.path !== '/account/manage'"></t-header>
        <keep-alive :include="includeList">
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
    <!-- <t-footer></t-footer> -->
    <change-pwd-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></change-pwd-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapState } from 'vuex';
import apis from '@/utils/apis';
import tHeader from './header.vue';
import changePwdDialog from '../pages/accountManage/children/change_pwd_dialog.vue';
// import tFooter from './footer.vue';

export default {
  components: { tHeader, changePwdDialog },
  name: 'layout',
  data() {
    return {
      appMenu: [], // 菜单列表
      windowHeight: document.documentElement.clientHeight || 0,
      windowWidth: document.documentElement.clientWidth || 0,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    ...mapState({
      includeList: state => state.vm.includeList,
    }),
    currentPath() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  mounted: function () {
    this.getAppLanguage();
    this.onPswdLoginChange();
    this.initAppMenu();
    this.onresize();
    this.getBigCustomer();
  },
  methods: {
    // 获取应用多语言(菜单多语言+组件多语言)
    getAppLanguage() {
      Promise.all([this.$getJSON(apis.LanguagePlatform, { appCode: 'customer-portal' }), this.$getJSON(apis.LanguagePlatformListForApp, { appCode: 'customer-portal' })]).then(([res1, res2]) => {
        const langCode = Cookies.get('langCode') || 'CN';
        this.$i18n.mergeLocaleMessage(langCode, Object.assign({ portal: res1.data }, res2.data));
      });
    },
    onPswdLoginChange() {
      const isShow = this.$store.state.pswdLoginChange;
      if (isShow === '1') {
        setTimeout(() => {
          this.dialogModel = { type: 'window' };
          this.dialogVisible = true;
        }, 600);
      }
    },
    onresize: function () {
      window.onresize = () => (() => {
        this.windowHeight = document.documentElement.clientHeight || 0; // 高
        this.windowWidth = document.documentElement.clientWidth || 0; // 宽
      })();
    },
    // 初始化菜单
    initAppMenu: function () {
      this.$getJSON(apis.App, { appCode: 'customer-portal' }).then((res) => {
        this.appMenu = res.data || [];
      });
    },
    // 点击目录跳转
    onMenuLink: function (value) {
      this.$router.push(`${value.loadRes}`);
    },
    // 是否显示子公司
    getBigCustomer() {
      Cookies.set('showSubsidiary', false, { path: '/' });
      this.$getJSON(apis.FuncView, { loadRes: '/largeCustomer' }).then((res) => {
        Cookies.set('showSubsidiary', !!res.data.showSubsidiary, { path: '/' });
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';
.layout-bd {
  min-height: 100%;
  .layout-aside {
    width: 250px;
    .logo {
      height: 88px;
      padding-top: 36px;
      img {
        width: 168px;
        display: block;
        margin: 0 auto;
      }
    }
    .bar {
      img {
        width: 202px;
        display: block;
        margin: 0 auto;
      }
    }
    .menu {
      padding-left: 24px;
      padding-right: 24px;
      padding-top: 18px;
      padding-bottom: 18px;
      overflow: auto;
      .title {
        & > li {
          h1 {
            height: 15px;
            margin-top: 12px;
            margin-bottom: 12px;
            font-weight: bold;
            font-size: 10px;
            color: #1a1a1a;
          }
        }
      }
      .sub-title {
        & > li {
          height: 54px;
          padding-left: 12px;
          display: flex;
          cursor: pointer;
          justify-content: center;
          align-items: center;
          &.cur {
            border-radius: 54px;
            background-color: #ffffff;
            .tit-icon {
              background: #00a0d9;
            }
            .tit-h2 h2 {
              color: #202945 !important;
            }
            i.icon {
              color: #ffffff;
            }
          }
        }
        .tit-icon {
          height: 30px;
          width: 30px;
          border-radius: 30px;
          box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02);
          background-color: #ffffff;
          text-align: center;
          margin-right: 12px;
          i.icon {
            line-height: 30px;
            font-size: 17px;
            color: #00a0d9;
          }
        }
        .tit-h2 {
          flex: 1;
          h2 {
            font-weight: bold;
            font-size: 14px;
            color: #4d4d4d;
          }
        }
      }
    }
  }

  .content11111111 {
    flex: 1;
    height: 0;
    position: relative;

    // 包含（搜索栏，表格等）内容
    & > .bd {
      height: 100%;
      padding: 16px;
      position: relative;
      //  左右结构
      & > .aside {
        position: absolute;
        // box-shadow: 0.5px 0px 3px 0px rgba(51, 51, 51, 0.12);
        top: 0;
        left: 0;
        bottom: 0;
        width: 250px;
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
        // background-color: #ffffff;
        overflow: auto;
        .title {
          padding: 0 10px;
          line-height: 70px;
          color: #394668;
          font-weight: bold;
          font-size: 15px;
          .icon {
            float: left;
            font-size: 14px;
            margin-right: 8px;
            font-weight: normal;
            @include color_main();
          }
        }
        .search {
          margin: 0 10px 16px;
        }
        .list {
          .el-tree-node__content > .el-tree-node__expand-icon {
            display: none;
          }
          .el-tree-node__content .tree-item {
            padding-left: 10px;
          }
        }
        .list,
        .tree {
          flex: 1;
          margin: 0 10px;
          overflow-y: auto;
          .el-tree-node__content {
            line-height: 32px;
            height: 32px;
            &:hover {
              background-color: #f8f9fb;
            }
          }
          .el-tree-node__content > .el-tree-node__expand-icon {
            color: #495057;
            &.is-leaf {
              color: transparent;
            }
          }
          .is-current > .el-tree-node__content {
            background-color: #eef2f8 !important;
            .tree-item {
              @include color_main();
              .icon {
                @include color_main();
                font-size: 12px;
              }
              .disable {
                color: rgba(108, 117, 125, 0.5);
              }
            }
          }
          .tree-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            padding-right: 10px;
            overflow: hidden;
            color: #6c757d;
            .disable {
              color: rgba(108, 117, 125, 0.5);
            }
          }
        }
      }
      & > .section {
        height: 100%;
        margin-left: 240px;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        padding: 0 16px;
        &.padding0 {
          padding: 0;
        }
        .section-info {
          padding-top: 16px;
          table {
            width: 100%;
          }
          table tr {
            height: 44px;
            line-height: 44px;
            text-align: left;
            th {
              padding: 0 10px;
              font-size: 12px;
              color: #636e78;
              background-color: #f2f3fb;
            }
            td {
              padding: 0 10px;
              color: #6c757d;
              font-size: 12px;
              border-bottom: 1px solid #eef2f8;
            }
          }
        }
        .table-bd {
          flex: 1;
          height: 0;
        }
      }
    }
    // 只包含表格
    & > .tb {
      height: calc(100% - 32px);
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 0 16px;
      margin: 16px;
      background-color: #ffffff;
    }
    // 内联步骤页
    & > .flow {
      height: 100%;
      position: relative;
      overflow: auto;
      .aside {
        position: absolute;
        left: 0;
        top: 0;
        width: 220px;
        bottom: 0;
        background-color: #f9f9fd;
        .title {
          color: #394668;
          font-size: 14px;
          line-height: 70px;
          height: 70px;
          font-weight: bold;
          padding-left: 24px;
          .icon {
            @include color_main();
            font-size: 18px;
            margin-right: 8px;
            float: left;
          }
        }
      }
      .section {
        flex: 1;
        background-color: #ffffff;
        margin-left: 220px;
        padding: 24px 24px 60px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        .footer {
          position: absolute;
          box-shadow: 0px -1px 0px 0px rgba(238, 242, 248, 1);
          left: 220px;
          right: 0;
          bottom: 0;
          height: 60px;
          z-index: 999;
          padding-top: 16px;
          padding-left: 24px;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>
